module.exports = __webpack_public_path__ + "img/tip_2.cd7a8517.png";